import styled from 'styled-components';

// https://www.figma.com/file/pZZHuwNbapoBxoxGJFSyZJ/GI-Foundations?type=design&node-id=25-2&t=pZslRhH1ZwNtrFHa-0

var spacing = {
  '0': 0,
  '2': '2px',
  '4': '4px',
  '8': '8px',
  '12': '12px',
  '20': '20px',
  '24': '24px',
  '28': '28px',
  '32': '32px',
  '40': '40px',
  '48': '48px',
  '56': '56px',
  '64': '64px'
};
var buildSpacing = function buildSpacing() {
  return spacing;
};

var Box = styled.div(function (_ref) {
  var _ref$mr = _ref.mr,
    mr = _ref$mr === void 0 ? '' : _ref$mr,
    _ref$mt = _ref.mt,
    mt = _ref$mt === void 0 ? '' : _ref$mt,
    _ref$ml = _ref.ml,
    ml = _ref$ml === void 0 ? '' : _ref$ml,
    _ref$mb = _ref.mb,
    mb = _ref$mb === void 0 ? '' : _ref$mb,
    _ref$my = _ref.my,
    my = _ref$my === void 0 ? '' : _ref$my,
    _ref$mx = _ref.mx,
    mx = _ref$mx === void 0 ? '' : _ref$mx,
    _ref$pt = _ref.pt,
    pt = _ref$pt === void 0 ? '' : _ref$pt,
    _ref$pr = _ref.pr,
    pr = _ref$pr === void 0 ? '' : _ref$pr,
    _ref$pb = _ref.pb,
    pb = _ref$pb === void 0 ? '' : _ref$pb,
    _ref$pl = _ref.pl,
    pl = _ref$pl === void 0 ? '' : _ref$pl,
    _ref$py = _ref.py,
    py = _ref$py === void 0 ? '' : _ref$py,
    _ref$px = _ref.px,
    px = _ref$px === void 0 ? '' : _ref$px;
  return "\n\tmargin-right: " + (spacing[mr || mx] || '') + ";\n\tmargin-left: " + (spacing[ml || mx] || '') + ";\n\tmargin-top: " + (spacing[mt || my] || '') + ";\n\tmargin-bottom: " + (spacing[mb || my] || '') + ";\n\tpadding-right: " + (spacing[pr || px] || '') + ";\n\tpadding-left: " + (spacing[pl || px] || '') + ";\n\tpadding-top: " + (spacing[pt || py] || '') + ";\n\tpadding-bottom: " + (spacing[pb || py] || '') + ";\n";
});

export { Box as B, buildSpacing as b };
